import React from 'react';
import './SeoServices.css';
import seoImage from '../assets/SEO.png';
import mobileImage from '../assets/Swift for iOS App Development (2).jpg';

const SeoServices = () => {
  return (
    <div className="seo-services">
      <section className="seo-content">
        <div className="container seo-hero-container">
          <div className="seo-hero-image">
            <picture>
              <source media="(max-width: 768px)" srcSet={mobileImage} />
              <img src={seoImage} alt="SEO Service" />
            </picture>
          </div>
          <div className="seo-hero-text">
            <h2>Our Vision</h2>
            <h3>Top-Quality SEO Services to Boost Your Online Presence</h3>
            <p>Search Engine Optimization (SEO) is the key to increasing your website's visibility and ranking on search engine results pages (SERPs). Our expert SEO services combine technical precision with creative strategies—covering keyword research, content optimization, link building, and website performance enhancements—to help you attract more traffic and grow your business online.</p>
            <button className="seo-cta-button">Get Started Today</button>
          </div>
        </div>
      </section>

      <section className="seo-cards">
        <div className="container">
          <h2>How We Can Help?</h2>
          <div className="cards-grid">
            <div className="card">
              <img src={require('../assets/keyword (1).png')} alt="Keyword Research" className="card-icon" />
              <h3>Keyword Research</h3>
              <p>We identify valuable search terms to reach your most relevant audience.</p>
            </div>
            <div className="card">
              <img src={require('../assets/onpageopt.png')} alt="On-Page Optimization" className="card-icon" />
              <h3>On-Page Optimization</h3>
              <p>We optimize site content and structure to boost visibility and usability.</p>
            </div>
            <div className="card">
              <img src={require('../assets/off-page-seo.png')} alt="Off-Page Optimization" className="card-icon" />
              <h3>Off-Page Optimization</h3>
              <p>We build authority with quality backlinks and external SEO efforts.</p>
            </div>
            <div className="card">
              <img src={require('../assets/socialmediastr.png')} alt="Social Media Strategy" className="card-icon" />
              <h3>Social Media Strategy</h3>
              <p>We create targeted plans to grow your presence and drive engagement.</p>
            </div>
            <div className="card">
              <img src={require('../assets/ads.png')} alt="Media Management" className="card-icon" />
              <h3>Media Management</h3>
              <p>We manage and optimize visual assets for better brand performance.</p>
            </div>
            <div className="card">
              <img src={require('../assets/reportandana.png')} alt="Reporting & Analysis" className="card-icon" />
              <h3>Reporting & Analysis</h3>
              <p>We track performance and provide insights to improve your strategy.</p>
            </div>
            <div className="card">
              <img src={require('../assets/cro.png')} alt="Conversion Rate Optimization" className="card-icon" />
              <h3>Conversion Rate Optimization (CRO)</h3>
              <p>We focus on converting visitors into customers by improving your site’s design and layout.</p>
            </div>
            <div className="card">
              <img src={require('../assets/competitors.png')} alt="Competitor Analysis" className="card-icon" />
              <h3>Competitor Analysis</h3>
              <p>We analyze your competitors to identify opportunities and threats.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SeoServices;
